export const DECREE_TYPE_ENLIST = 'ENLIST';
export const DECREE_TYPE_GUARD = 'GUARD';
export const DECREE_TYPE_MARCH = 'MARCH';
export const DECREE_TYPE_REDEPLOY = 'REDEPLOY';
export const DECREE_TYPE_REINFORCE = 'REINFORCE';
export const DECREE_TYPE_SACRIFICE = 'SACRIFICE';
export const DECREE_TYPE_SPY = 'SPY';

export interface IDecreeTypeResource {
    id: number;
    name: string;
    type: string;
    className: string;
    description: string;
}

export interface IDecree {
    id: number;
    gameId: number;
    decreeTypeId: number;
    whiteTeamId: number;
    blackTeamId: number;
    type: string;
    name: string;
}
